import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Person: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 14.4h11a.4.4 0 0 0 .4-.4 3.4 3.4 0 0 0-3.4-3.4h-5A3.4 3.4 0 0 0 2.1 14c0 .22.18.4.4.4Zm0 1.6h11a2 2 0 0 0 2-2 5 5 0 0 0-5-5h-5a5 5 0 0 0-5 5 2 2 0 0 0 2 2ZM8 6.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8ZM8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
            ></path>
        </Icon>
    );
};
